import {TypeDecorator} from '@angular/core';
import {SignalStoreV0} from '@shared-types';

const RESETABLE_STORES_LOGOUT: SignalStoreV0<any>[] = [];
const RESETABLE_STORES_NEVER: SignalStoreV0<any>[] = [];

/**
 * @description This decorator mark the signal store as resetable:
 * * `logout` - reset the store on user logout
 * * `never` - never reset the store
 *	@note the store must be a SignalStore (from @shared-types) and must be implement `reset()` method
 * @param config
 * @constructor
 */
export function ResetableStore(config: {resetOn: 'logout' | 'never'}): TypeDecorator {
	return function (target: SignalStoreV0<any>) {
		if (config.resetOn === 'logout') RESETABLE_STORES_LOGOUT.push(target);
		else RESETABLE_STORES_NEVER.push(target);
	};
}

/**
 * @description Get the list of resetable stores
 * @param on
 * @returns
 */
export const getResetableStores = (on: 'logout' | 'never') => (on === 'logout' ? RESETABLE_STORES_LOGOUT : RESETABLE_STORES_NEVER);
